<template>
    <my-tag :type="item.type" @click="item.click" class="sh-state">{{item.text}}</my-tag>
</template>

<script>
import STATE_CONF from '../config/sh-state'

export default {
    components: {},
    props: {
        row: {
            type: Object,
            default: () => ({})
        }
    },
    data: () => ({
        STATE_CONF
    }),
    computed: {
        item() {
            return this.STATE_CONF.filter(item => {
                return item.show(this.row);
            }).map(item => ({
                type: item.type,
                text: getType(item.text) === 'function' ? item.text(this.row) : item.text,
                click: getType(item.click) === 'function' ? item.click.bind(this) : () => {}
            }))[0];
        }
    },
    methods: {
        tuiSongHandler(row) {
            this.$refs.base.showConfirm(() => {
                this.$refs.base.doPush({
                    yqscode: row.yqstszt
                });
            });
        }
    }
}
</script>

<style scoped lang="scss">
.sh-state{cursor:pointer;}
</style>
